'use client';

import { useState, createContext, useMemo } from 'react';
import { useTranslation } from '@weareconceptstudio/core';

const DataContext = createContext(null);
export const DataConsumer = DataContext.Consumer;

const DataProvider = (props) => {
	const { selectedLang } = useTranslation();

	const [state, setState] = useState({
		...props.newData,
		prevRoute: null,
	});

	const enableLoading = () => {
		this.setState({ loading: true });
	};

	const disableLoading = () => {
		setState((prev) => ({ ...prev, loading: false }));
	};

	const globalData = useMemo(() => state.globalData?.[selectedLang], [selectedLang, state]);

	const methods = {
		enableLoading,
		disableLoading,
	};

	return <DataContext.Provider value={{ ...state, ...methods, globalData }}>{props.children}</DataContext.Provider>;
};

export default DataProvider;
